import "./App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Services from "./components/Services";
import ClientsServices from "./components/ClientsServices";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import ZoneIntervention from "./components/ZoneIntervention";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";
import VipSubscription from "./components/VipSubscription";

// Lazy loading pour les pages (chargées uniquement quand visitées)
const ServiceCityPage = lazy(() => import("./components/ServiceCityPage"));
const GuideDebouchage = lazy(() => import("./pages/GuideDebouchage"));

// Pages Débouchage par ville - Lazy loaded
const DebouchageCannes = lazy(() => import("./pages/debouchage/DebouchageCannes"));
const DebouchageLeCannet = lazy(() => import("./pages/debouchage/DebouchageLeCannet"));
const DebouchageLaBocca = lazy(() => import("./pages/debouchage/DebouchageLaBocca"));
const DebouchageMandelieu = lazy(() => import("./pages/debouchage/DebouchageMandelieu"));
const DebouchageGrasse = lazy(() => import("./pages/debouchage/DebouchageGrasse"));
const DebouchagePegomas = lazy(() => import("./pages/debouchage/DebouchagePegomas"));
const DebouchageMougins = lazy(() => import("./pages/debouchage/DebouchageMougins"));
const DebouchageVallauris = lazy(() => import("./pages/debouchage/DebouchageVallauris"));
const DebouchageAntibes = lazy(() => import("./pages/debouchage/DebouchageAntibes"));
const DebouchageGolfeJuan = lazy(() => import("./pages/debouchage/DebouchageGolfeJuan"));
const DebouchageJuanLesPins = lazy(() => import("./pages/debouchage/DebouchageJuanLesPins"));
const DebouchageLeSuquet = lazy(() => import("./pages/debouchage/DebouchageLeSuquet"));
const DebouchageCalifornia = lazy(() => import("./pages/debouchage/DebouchageCalifornia"));
const DebouchagePezou = lazy(() => import("./pages/debouchage/DebouchagePezou"));
const DebouchagePeymeinade = lazy(() => import("./pages/debouchage/DebouchagePeymeinade"));
const DebouchageMouansSartoux = lazy(() => import("./pages/debouchage/DebouchageMouansSartoux"));

// Nouvelles pages débouchage - Lazy loaded
const DebouchageNice = lazy(() => import("./pages/debouchage/DebouchageNice"));
const DebouchageCagnesSurMer = lazy(() => import("./pages/debouchage/DebouchageCagnesSurMer"));
const DebouchageMenton = lazy(() => import("./pages/debouchage/DebouchageMenton"));
const DebouchageSaintLaurentDuVar = lazy(() => import("./pages/debouchage/DebouchageSaintLaurentDuVar"));
const DebouchageVilleneuveLoubet = lazy(() => import("./pages/debouchage/DebouchageVilleneuveLoubet"));
const DebouchageMonaco = lazy(() => import("./pages/debouchage/DebouchageMonaco"));

// 7 nouvelles villes - Lazy loaded
const DebouchageVence = lazy(() => import("./pages/debouchage/DebouchageVence"));
const DebouchageVillefrancheSurMer = lazy(() => import("./pages/debouchage/DebouchageVillefrancheSurMer"));
const DebouchageBeaulieuSurMer = lazy(() => import("./pages/debouchage/DebouchageBeaulieuSurMer"));
const DebouchageSaintJeanCapFerrat = lazy(() => import("./pages/debouchage/DebouchageSaintJeanCapFerrat"));
const DebouchageBiot = lazy(() => import("./pages/debouchage/DebouchageBiot"));
const DebouchageCarros = lazy(() => import("./pages/debouchage/DebouchageCarros"));
const DebouchageRoquebrunCapMartin = lazy(() => import("./pages/debouchage/DebouchageRoquebrunCapMartin"));

// 40 nouvelles villes du 06 - Lazy loaded
const DebouchageValbonne = lazy(() => import("./pages/debouchage/DebouchageValbonne"));
const DebouchageEze = lazy(() => import("./pages/debouchage/DebouchageEze"));
const DebouchageLaTurbie = lazy(() => import("./pages/debouchage/DebouchageLaTurbie"));
const DebouchageBeausoleil = lazy(() => import("./pages/debouchage/DebouchageBeausoleil"));
const DebouchageCapDAil = lazy(() => import("./pages/debouchage/DebouchageCapDAil"));
const DebouchageTheouleSurMer = lazy(() => import("./pages/debouchage/DebouchageTheouleSurMer"));
const DebouchageTourrettesSurLoup = lazy(() => import("./pages/debouchage/DebouchageTourrettesSurLoup"));
const DebouchageSaintPaulDeVence = lazy(() => import("./pages/debouchage/DebouchageSaintPaulDeVence"));
const DebouchageLaColleSurLoup = lazy(() => import("./pages/debouchage/DebouchageLaColleSurLoup"));
const DebouchageLaGaude = lazy(() => import("./pages/debouchage/DebouchageLaGaude"));
const DebouchageSaintJeannet = lazy(() => import("./pages/debouchage/DebouchageSaintJeannet"));
const DebouchageGattieres = lazy(() => import("./pages/debouchage/DebouchageGattieres"));
const DebouchageLeBroc = lazy(() => import("./pages/debouchage/DebouchageLeBroc"));
const DebouchageAspremont = lazy(() => import("./pages/debouchage/DebouchageAspremont"));
const DebouchageColomars = lazy(() => import("./pages/debouchage/DebouchageColomars"));
const DebouchageCastagniers = lazy(() => import("./pages/debouchage/DebouchageCastagniers"));
const DebouchageTourretteLevens = lazy(() => import("./pages/debouchage/DebouchageTourretteLevens"));
const DebouchageLevens = lazy(() => import("./pages/debouchage/DebouchageLevens"));
const DebouchageFalicon = lazy(() => import("./pages/debouchage/DebouchageFalicon"));
const DebouchageLaTrinite = lazy(() => import("./pages/debouchage/DebouchageLaTrinite"));
const DebouchageDrap = lazy(() => import("./pages/debouchage/DebouchageDrap"));
const DebouchageContes = lazy(() => import("./pages/debouchage/DebouchageContes"));
const DebouchagePeillon = lazy(() => import("./pages/debouchage/DebouchagePeillon"));
const DebouchagePeille = lazy(() => import("./pages/debouchage/DebouchagePeille"));
const DebouchageLEscarene = lazy(() => import("./pages/debouchage/DebouchageLEscarene"));
const DebouchageLuceram = lazy(() => import("./pages/debouchage/DebouchageLuceram"));
const DebouchageSospel = lazy(() => import("./pages/debouchage/DebouchageSospel"));
const DebouchageBreilSurRoya = lazy(() => import("./pages/debouchage/DebouchageBreilSurRoya"));
const DebouchageTende = lazy(() => import("./pages/debouchage/DebouchageTende"));
const DebouchageLaBrigue = lazy(() => import("./pages/debouchage/DebouchageLaBrigue"));
const DebouchageSaorge = lazy(() => import("./pages/debouchage/DebouchageSaorge"));
const DebouchageFontan = lazy(() => import("./pages/debouchage/DebouchageFontan"));
const DebouchageSaintAndreDeLaRoche = lazy(() => import("./pages/debouchage/DebouchageSaintAndreDeLaRoche"));
const DebouchageSaintMartinDuVar = lazy(() => import("./pages/debouchage/DebouchageSaintMartinDuVar"));
const DebouchageLaRoquetteSurSiagne = lazy(() => import("./pages/debouchage/DebouchageLaRoquetteSurSiagne"));
const DebouchageLeTignet = lazy(() => import("./pages/debouchage/DebouchageLeTignet"));
const DebouchageSperacedes = lazy(() => import("./pages/debouchage/DebouchageSperacedes"));
const DebouchageCabris = lazy(() => import("./pages/debouchage/DebouchageCabris"));
const DebouchageSaintVallierDeThiey = lazy(() => import("./pages/debouchage/DebouchageSaintVallierDeThiey"));
const DebouchageSaintCezaireSurSiagne = lazy(() => import("./pages/debouchage/DebouchageSaintCezaireSurSiagne"));

// Page générique pour les prestations/services
const ServicePage = lazy(() => import("./pages/ServicePage"));

// Loading component pour le lazy loading
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 to-teal-50">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-sky-200 border-t-sky-600 rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-sky-600 font-medium">Chargement...</p>
    </div>
  </div>
);

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Features />
        <Services />
        <ClientsServices />
        <Pricing />
        <Testimonials />
        <ZoneIntervention />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
};

// Liste des villes (toutes les villes avec pages dédiées)
const cities = [
  "cannes", "le-cannet", "la-bocca", "mandelieu-la-napoule", "grasse",
  "pegomas", "mougins", "vallauris", "antibes", "golfe-juan",
  "juan-les-pins", "le-suquet", "california", "pezou", "peymeinade", "mouans-sartoux"
];

// Liste des services
const services = [
  "inspection-camera", "entretien-bac-graisse", "pompe-relevage", "curage-haute-pression", "plombier-debouchage"
];

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              
              {/* Pages Prestations/Services */}
              <Route path="/inspection-camera" element={<ServicePage />} />
              <Route path="/entretien-bac-graisse" element={<ServicePage />} />
              <Route path="/pompe-relevage" element={<ServicePage />} />
              <Route path="/curage-haute-pression" element={<ServicePage />} />
              <Route path="/plombier-debouchage" element={<ServicePage />} />
              
              {/* Pages Débouchage par ville - Pages HTML individuelles */}
              <Route path="/debouchage-cannes" element={<DebouchageCannes />} />
              <Route path="/debouchage-le-cannet" element={<DebouchageLeCannet />} />
              <Route path="/debouchage-la-bocca" element={<DebouchageLaBocca />} />
              <Route path="/debouchage-mandelieu-la-napoule" element={<DebouchageMandelieu />} />
              <Route path="/debouchage-grasse" element={<DebouchageGrasse />} />
              <Route path="/debouchage-pegomas" element={<DebouchagePegomas />} />
              <Route path="/debouchage-mougins" element={<DebouchageMougins />} />
              <Route path="/debouchage-vallauris" element={<DebouchageVallauris />} />
              <Route path="/debouchage-antibes" element={<DebouchageAntibes />} />
              <Route path="/debouchage-golfe-juan" element={<DebouchageGolfeJuan />} />
              <Route path="/debouchage-juan-les-pins" element={<DebouchageJuanLesPins />} />
              <Route path="/debouchage-le-suquet" element={<DebouchageLeSuquet />} />
              <Route path="/debouchage-california" element={<DebouchageCalifornia />} />
              <Route path="/debouchage-pezou" element={<DebouchagePezou />} />
              <Route path="/debouchage-peymeinade" element={<DebouchagePeymeinade />} />
              <Route path="/debouchage-mouans-sartoux" element={<DebouchageMouansSartoux />} />
            
            {/* Nouvelles villes débouchage */}
            <Route path="/debouchage-nice" element={<DebouchageNice />} />
            <Route path="/debouchage-cagnes-sur-mer" element={<DebouchageCagnesSurMer />} />
            <Route path="/debouchage-menton" element={<DebouchageMenton />} />
            <Route path="/debouchage-saint-laurent-du-var" element={<DebouchageSaintLaurentDuVar />} />
            <Route path="/debouchage-villeneuve-loubet" element={<DebouchageVilleneuveLoubet />} />
            <Route path="/debouchage-monaco" element={<DebouchageMonaco />} />
            
            {/* 7 nouvelles villes */}
            <Route path="/debouchage-vence" element={<DebouchageVence />} />
            <Route path="/debouchage-villefranche-sur-mer" element={<DebouchageVillefrancheSurMer />} />
            <Route path="/debouchage-beaulieu-sur-mer" element={<DebouchageBeaulieuSurMer />} />
            <Route path="/debouchage-saint-jean-cap-ferrat" element={<DebouchageSaintJeanCapFerrat />} />
            <Route path="/debouchage-biot" element={<DebouchageBiot />} />
            <Route path="/debouchage-carros" element={<DebouchageCarros />} />
            <Route path="/debouchage-roquebrune-cap-martin" element={<DebouchageRoquebrunCapMartin />} />
            
            {/* 40 nouvelles villes du 06 */}
            <Route path="/debouchage-valbonne" element={<DebouchageValbonne />} />
            <Route path="/debouchage-eze" element={<DebouchageEze />} />
            <Route path="/debouchage-la-turbie" element={<DebouchageLaTurbie />} />
            <Route path="/debouchage-beausoleil" element={<DebouchageBeausoleil />} />
            <Route path="/debouchage-cap-d-ail" element={<DebouchageCapDAil />} />
            <Route path="/debouchage-theoule-sur-mer" element={<DebouchageTheouleSurMer />} />
            <Route path="/debouchage-tourrettes-sur-loup" element={<DebouchageTourrettesSurLoup />} />
            <Route path="/debouchage-saint-paul-de-vence" element={<DebouchageSaintPaulDeVence />} />
            <Route path="/debouchage-la-colle-sur-loup" element={<DebouchageLaColleSurLoup />} />
            <Route path="/debouchage-la-gaude" element={<DebouchageLaGaude />} />
            <Route path="/debouchage-saint-jeannet" element={<DebouchageSaintJeannet />} />
            <Route path="/debouchage-gattieres" element={<DebouchageGattieres />} />
            <Route path="/debouchage-le-broc" element={<DebouchageLeBroc />} />
            <Route path="/debouchage-aspremont" element={<DebouchageAspremont />} />
            <Route path="/debouchage-colomars" element={<DebouchageColomars />} />
            <Route path="/debouchage-castagniers" element={<DebouchageCastagniers />} />
            <Route path="/debouchage-tourrette-levens" element={<DebouchageTourretteLevens />} />
            <Route path="/debouchage-levens" element={<DebouchageLevens />} />
            <Route path="/debouchage-falicon" element={<DebouchageFalicon />} />
            <Route path="/debouchage-la-trinite" element={<DebouchageLaTrinite />} />
            <Route path="/debouchage-drap" element={<DebouchageDrap />} />
            <Route path="/debouchage-contes" element={<DebouchageContes />} />
            <Route path="/debouchage-peillon" element={<DebouchagePeillon />} />
            <Route path="/debouchage-peille" element={<DebouchagePeille />} />
            <Route path="/debouchage-l-escarene" element={<DebouchageLEscarene />} />
            <Route path="/debouchage-luceram" element={<DebouchageLuceram />} />
            <Route path="/debouchage-sospel" element={<DebouchageSospel />} />
            <Route path="/debouchage-breil-sur-roya" element={<DebouchageBreilSurRoya />} />
            <Route path="/debouchage-tende" element={<DebouchageTende />} />
            <Route path="/debouchage-la-brigue" element={<DebouchageLaBrigue />} />
            <Route path="/debouchage-saorge" element={<DebouchageSaorge />} />
            <Route path="/debouchage-fontan" element={<DebouchageFontan />} />
            <Route path="/debouchage-saint-andre-de-la-roche" element={<DebouchageSaintAndreDeLaRoche />} />
            <Route path="/debouchage-saint-martin-du-var" element={<DebouchageSaintMartinDuVar />} />
            <Route path="/debouchage-la-roquette-sur-siagne" element={<DebouchageLaRoquetteSurSiagne />} />
            <Route path="/debouchage-le-tignet" element={<DebouchageLeTignet />} />
            <Route path="/debouchage-speracedes" element={<DebouchageSperacedes />} />
            <Route path="/debouchage-cabris" element={<DebouchageCabris />} />
            <Route path="/debouchage-saint-vallier-de-thiey" element={<DebouchageSaintVallierDeThiey />} />
            <Route path="/debouchage-saint-cezaire-sur-siagne" element={<DebouchageSaintCezaireSurSiagne />} />
            
            {/* Page Guide Débouchage */}
            <Route path="/guide-debouchage" element={<GuideDebouchage />} />
            
            {/* Pages Services par ville */}
            {services.map(service => 
              cities.map(city => (
                <Route key={`${service}-${city}`} path={`/${service}/${city}`} element={<ServiceCityPage />} />
              ))
            )}
          </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;